<template>
    <v-dialog v-model="show" scrollable hide-overlay max-width="500">
        <v-card>
            <pad-card-title :label="title" @close="show = false" />
            <v-card-text v-html="message"></v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import PadCardTitle from '@/components/PadCardTitle'

export default {
    name: 'pad-message-popup',
    components: { PadCardTitle },
    computed: {
        show: {
            get() {
                return this.$store.getters['msg/show']
            },
            set(v) {
                this.$store.commit('msg/showPopup', { })
            }
        },
        message() {
            return this.$store.getters['msg/message']
        },
        title() {
            return this.$store.getters['msg/title']
        }
    }
}
</script>
